import Avatar from './avatar';
import Verified from './verified';

export{
  Avatar,
  Verified,
}